import MainButton from '../MainButton/MainButton';
import './HomepageButton.css';

export default function HomepageButton(props) {
    return <MainButton {...props} className="homepage-button" ></MainButton>;
}
